"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AccordionWorkflowItem", {
  enumerable: true,
  get: function get() {
    return _AccordionWorkflowItem["default"];
  }
});
Object.defineProperty(exports, "AccordionWorkflowSummary", {
  enumerable: true,
  get: function get() {
    return _AccordionWorkflowSummary["default"];
  }
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _AccordionWorkflow = _interopRequireDefault(require("./AccordionWorkflow.context"));

var _AccordionWorkflow2 = require("./AccordionWorkflow.styles");

var _AccordionWorkflowItem = _interopRequireDefault(require("./AccordionWorkflowItem/AccordionWorkflowItem.index"));

var _AccordionWorkflowSummary = _interopRequireDefault(require("./AccordionWorkflowItem/AccordionWorkflowSummary.index"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AccordionWorkflow = function AccordionWorkflow(_ref) {
  var children = _ref.children,
      type = _ref.type;
  var accordionRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react["default"].createElement(_AccordionWorkflow["default"].Provider, {
    value: {
      type: type
    }
  }, /*#__PURE__*/_react["default"].createElement(_AccordionWorkflow2.StyledAccordion, {
    ref: accordionRef
  }, children));
};

AccordionWorkflow.AccordionWorkflowItem = _AccordionWorkflowItem["default"];
AccordionWorkflow.AccordionWorkflowSummary = _AccordionWorkflowSummary["default"];
AccordionWorkflow.defaultProps = {
  type: 'normal'
};
var accordionWorkflowItem = (0, _propTypes.shape)({
  type: (0, _propTypes.oneOf)([_AccordionWorkflowItem["default"], _AccordionWorkflowSummary["default"]])
});
AccordionWorkflow.propTypes = {
  /** Accordion Items to be rendered */
  children: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(accordionWorkflowItem), accordionWorkflowItem]).isRequired,

  /** Defines the title typography */
  type: (0, _propTypes.oneOf)(['heading', 'normal'])
};
AccordionWorkflow.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AccordionWorkflow",
  "props": {
    "type": {
      "defaultValue": {
        "value": "'normal'",
        "computed": false
      },
      "description": "Defines the title typography",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'heading'",
          "computed": false
        }, {
          "value": "'normal'",
          "computed": false
        }]
      },
      "required": false
    },
    "children": {
      "description": "Accordion Items to be rendered",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "custom",
            "raw": "accordionWorkflowItem"
          }
        }, {
          "name": "custom",
          "raw": "accordionWorkflowItem"
        }]
      },
      "required": true
    }
  }
};
var _default = AccordionWorkflow;
exports["default"] = _default;